import React from "react";
import {
  Container,
  Box,
  Typography,
  List,
  ListItem,
  Divider,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const AdditionalTermsPage = () => {
  const { t } = useTranslation();

  const title = t("additional_terms.title");
  const lastUpdated = t("additional_terms.lastUpdated", { defaultValue: "" });
  const sections =
    t("additional_terms.sections", { returnObjects: true }) || [];

  return (
    <Container
      maxWidth="md"
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        px: 2,
      }}
    >
      <Box
        className="white-background"
        sx={{
          width: "100%",
          maxWidth: 900,
          p: { xs: 2, sm: 4 },
          borderRadius: 2,
          textAlign: "left",
          overflowY: "auto",
        }}
      >
        {/* Title */}
        <Typography variant="h3" color="primary" gutterBottom>
          {title}
        </Typography>

        {/* Last updated (optional) */}
        {lastUpdated ? (
          <Typography variant="body2" color="text.secondary">
            {lastUpdated}
          </Typography>
        ) : null}

        <Divider sx={{ my: 3 }} />

        {/* Sections */}
        {sections.map((sec, idx) => (
          <Box key={idx} sx={{ mb: 3 }}>
            {sec.heading && (
              <Typography variant="h5" color="primary" gutterBottom>
                {sec.heading}
              </Typography>
            )}

            {sec.text && (
              <Typography
                variant="body1"
                paragraph
                style={{ whiteSpace: "pre-line" }}
              >
                {sec.text}
              </Typography>
            )}

            {Array.isArray(sec.list) && sec.list.length > 0 && (
              <List dense sx={{ pl: 0 }}>
                {sec.list.map((item, i) => (
                  <ListItem key={i} sx={{ pl: 0 }}>
                    <Typography variant="body2">{item}</Typography>
                  </ListItem>
                ))}
              </List>
            )}
          </Box>
        ))}
      </Box>
    </Container>
  );
};

export default AdditionalTermsPage;
